console.log("testing");


(function() {
    setInterval(function() {
        var fileInput = document.getElementById('file-upload');
        if (fileInput) {
            fileInput.accept = '.png,.jpg,.jpeg';
        }
    }, 500);
})();